<div class="linq-dialog">
	<div class="linq-dialog__header">
		<div class="col">
			<h3 class="linq-heading" [innerHTML]="title"></h3>
			<h4 *ngIf="subtitle" class="linq-subheading" [innerHTML]="subtitle"></h4>
		</div>
	</div>
	<sl-feedback-panel variant="error" context="modal"></sl-feedback-panel>
	<sl-feedback-panel variant="warn" context="modal"></sl-feedback-panel>
	<div class="linq-dialog__content linq-dialog__content_scroll"
		[ngClass]="{ 'remove-padding' : removeContentPadding === true, 'remove-padding-top' : removeContentPaddingTop === true }">
		<div *ngIf="message" [innerHTML]="message"></div>
		<ng-content></ng-content>
		<div *ngIf="form">
			<form [formGroup]="form" (ngSubmit)="onSubmit()">
				<div class="linq-dialog__content linq-dialog__content_scroll">
					<formly-form [form]="form" [fields]="fields" [model]="model" [options]="options">
					</formly-form>
				</div>
			</form>
		</div>
	</div>
	<mat-dialog-actions class="linq-dialog__actions">
		<button class="linq-button linq-button--secondary linq-button--{{ cancelColor }}-stroked" [color]="cancelColor"
			(click)="onCancelClick($event)" mat-stroked-button *ngIf="showCancel">
			{{ cancelText }}
		</button>
		<span class="spacer"></span>
		<ng-container *ngIf="!useButtonWithMenuItems; else useMatMenu">
			<button class="linq-button linq-button--primary" *ngIf="!okDisabled && !okHidden" [color]="okColor" [disabled]="form?.invalid"
				(click)="onOkClick($event)" mat-flat-button cdkFocusInitial>
				{{ okText }}
			</button>
			<button class="linq-button linq-button--primary" *ngIf="okDisabled && !okHidden" [color]="okColor" [disabled]="okDisabled"
				mat-flat-button>
				{{ okText }}
			</button>
			<button class="linq-button linq-button--primary" *ngFor="let button of customButtons" [color]="okColor" [disabled]="okDisabled"
				(click)="button.action()" mat-flat-button>
				{{ button.text }}
			</button>
		</ng-container>
		<ng-template #useMatMenu>
			<button [disabled]="okDisabled" class="linq-button linq-button--primary" [color]="okColor" mat-flat-button [matMenuTriggerFor]="menu">
				{{ okText }}
				<mat-icon>keyboard_arrow_down</mat-icon>
			</button>
			<mat-menu #menu="matMenu" xPosition="before" class="linq-dialog__menu">
				<button mat-menu-item *ngFor="let button of customButtons" (click)="button.action()">
					{{ button.text }}
				</button>
			</mat-menu>
		</ng-template>
	</mat-dialog-actions>
</div>